import axios from 'axios';

// Configuration de base pour l'API - URLs relatives pour HTTPS
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Instance Axios configurée
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,  // Timeout par défaut (peut être surchargé par requête)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(
  (config) => {
    // Utiliser le token admin si disponible, sinon token admin de test
    const adminToken = localStorage.getItem('adminToken');
    const testAdminToken = 'admin_token_2025';
    
    const token = adminToken || testAdminToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Pour les requêtes logs/download, augmenter le timeout si non défini
    if (config.url && config.url.includes('/logs/download') && !config.timeout) {
      config.timeout = 40000; // 40 secondes pour les requêtes de logs
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Services API
export const stationService = {
  // Récupérer toutes les stations
  async getStations(filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
    const response = await api.get(`/api/v1/stations?${params}`);
    return response.data;
  },

  // Récupérer une station spécifique
  async getStation(stationId) {
    const response = await api.get(`/api/v1/stations/${stationId}`);
    return response.data;
  },

  // Envoyer une commande à une station
  async sendCommand(stationId, command) {
    const response = await api.post(`/api/v1/stations/${stationId}/commands`, command);
    return response.data;
  },

  // Récupérer les commandes en attente d'une station
  async getCommands(stationId) {
    const response = await api.get(`/api/v1/stations/${stationId}/commands`);
    return response.data;
  },

  // Récupérer les événements d'une station
  async getEvents(stationId, filters = {}) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
    const response = await api.get(`/api/v1/stations/${stationId}/events?${params}`);
    return response.data;
  },
};

export const systemService = {
  // Vérifier l'état du système
  async getHealth() {
    const response = await api.get('/health');
    return response.data;
  },

  // Récupérer les métriques système
  async getMetrics() {
    const response = await api.get('/metrics');
    return response.data;
  },
};

export const authService = {
  // Connexion utilisateur
  async login(credentials) {
    const response = await api.post('/auth/login', credentials);
    if (response.data.access_token) {
      localStorage.setItem('authToken', response.data.access_token);
    }
    return response.data;
  },

  // Déconnexion
  logout() {
    localStorage.removeItem('authToken');
    window.location.href = '/login';
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  },
};

export default api;
